const os = {
    isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1,
    isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    isSuperApp: !!(~navigator.userAgent.toLocaleLowerCase().indexOf('superapp'))
};
const eventNames = [
    'onLoad',
    'onShow',
    'onHide',
    'onLogin',
    'onLogout',
    'onShare',
    'onScrollTo',
    'onClickRightAction'
];
const methodNames = [
    'showLoading',
    'hideLoading',
    'toast',
    'alert',
    'modal',
    'actionSheet',
    'onWebReady',
    'navigateURL',
    'navigateTo',
    'navigateBack',
    'switchTab',
    'previewImage',
    'previewVideo',
    'saveImageToPhotosAlbum',
    'encryptParam',
    'getUserInfo',
    'getAppConfig',
    'tokenInvalid',
    'login',
    'logout',
    'uniApi',
    'bombApi',
    'plusApi',
    'qimoApi',
    'emit',
    'statistics',
    'setStatusBarStyle',
    'setWebviewBounces',
    'setWebviewCloseBtn',
    'pay',
    'redirectTo',
    'getPageConfig',
    'getRequestConfig',
    'showNavbar',
    'previewImage',
    'chooseImage',
    'sign',
    'share',
    'scanCode',
    'callPay',
];
export { os, eventNames, methodNames };
//# sourceMappingURL=utils.js.map